import { SurveySingleSelectOptions } from '@/models/survey-elements/single-select-options';
import { Expose, Type } from 'class-transformer';
import { SINGLE_SELECT_TYPE } from '@/models/enums/single-select-type';

export class SingleSelectProps {
  @Expose()
  title?: string;

  @Expose()
  @Type(() => SurveySingleSelectOptions)
  options!: SurveySingleSelectOptions[];

  @Expose()
  type!: SINGLE_SELECT_TYPE;

  @Expose()
  value!: SurveySingleSelectOptions | null;

  @Expose()
  externalApiIdentifier!: string | null;
}
